export default "<h5 class=\"cash-in-transaction {{ textClass }}\">{{ statustext }} ({{ riderTransaction.updatedAt.toDate() | date:'medium' }})</h5>\n"